export default __webpack_public_path__ + "static/media/EAST2570.34I-34707_-19303_0.75041ee4.jpg";